<template>
  <HXContentCard title="Editar Marca" :toBack="{ name: 'Marcas' }">
    <form @submit.prevent="saveData">
      <div class="row px-5 mt-4">
        <div class="col-md-6">
          <div>
            <label for=" " class="form-label">Nombre Marca</label>
            <input v-model="item.descripcion" required placeholder="Escriba el Nombre de la Marca..." type="text"
              class="form-control" id=" " />
          </div>
        </div>

        <div class="col-md-6">
          <div class="mb-3">
            <label for=" " class="form-label">Empresa</label>
            <b-form-select :disabled="usuario.rol.nivel != 4 ? true : false" required v-model="item.empresa.id"
              :options="ListEmpresas" text-field="nombre" value-field="id"></b-form-select>
          </div>
        </div>
      </div>
      <div class="text-right px-5 pb-4 d-flex justify-content-end">
        <vs-button icon animation-type="vertical" type="submit">
          <i class="fas fa-save pr-1"></i>
          Actualizar Marca
          <template #animate>
            <i class="fas fa-save"></i>
          </template>
        </vs-button>
      </div>
    </form>
  </HXContentCard>
</template>
<script>
export default {
  data() {
    return {
      item: {
        empresa: {
          id: "",
        },
      },
      isCreating: false,
      ListEmpresas: [],
      selected: null,
      empresaSelected: null,
      usuario: { rol: { nivel: 0 } },
      id: "",
    };
  },
  async mounted() {
    try {
      this.$isLoading(true);
      this.id = this.$route.params.id;
      this.usuario = JSON.parse(localStorage.getItem("setPersonaAct"));
      console.log("usuario ", this.usuario);
      //this.item.EmpresaId = this.usuario.empresa.id;
      await this.getData();
      await this.getEmpresas();
      this.$isLoading(false);
    } catch (error) {
      console.log("error", error);
    }
  },
  methods: {
    async getData() {
      try {
        let res = await this.$store.dispatch("hl_get", {
          path: "Marca/Get/" + this.id,
        });
        this.item = res;

        console.log("list data Marca* ************* ", this.item);
      } catch (error) {
        this.item = {};
        console.log("err", error);
      }
    },
    async getEmpresas() {
      try {
        let res = await this.$store.dispatch("hl_post", {
          path: "Empresa/ListEmpresa/",
        });
        this.ListEmpresas = res;

        console.log("list", this.ListEmpresas);
      } catch (error) {
        this.ListEmpresas = {};
        console.log("err", error);
      }
    },
    async saveData() {
      this.isCreating = true;

      try {
        this.item.EmpresaId = this.item.empresa.id;

        const res = await this.$store.dispatch("hl_post", {
          path: "Marca/Update/",
          data: this.item,
        });

        if (res) {
          this.$vs.notification({
            progress: "auto",
            icon: `<i class='fas fa-check-circle'></i>`,
            color: "success",
            position: "top-right",
            title: "Éxito",
            text: "¡Marca actualizada exitosamente!",
          });

          this.$router.push("/helex/Marcas");
        } else {
          this.$vs.notification({
            progress: "auto",
            icon: `<i class='fas fa-exclamation-triangle'></i>`,
            color: "warning",
            position: "top-right",
            title: "Advertencia",
            text: "No se pudo guardar la información. Verifica los datos.",
          });
        }
      } catch (error) {
        console.error("Error en saveData:", error);

        this.$vs.notification({
          progress: "auto",
          icon: `<i class='fas fa-times-circle'></i>`,
          color: "danger",
          position: "top-right",
          title: "Error",
          text: "Ocurrió un error al guardar la marca.",
        });

        this.item = {};
      } finally {
        this.isCreating = false;
      }
    }

  },
};
</script>
